import type { RouteRecordRaw } from 'vue-router';

import { contactsPublicRoutes } from '@/modules/contacts/router/contacts.public.route';
import { legalRepConfirmationPublicRoutes } from '@/shared/legalRepConfirmation/router/legalRepConfirmation.public.route';
import { jumioRegularizationPublicRoutes } from '@/shared/jumioRegularization/router/jumioRegularization.public.route';
import { authPublicRoutes } from '@/modules/authentication/router/auth.public.route';
import { mcpPublicRoutes } from '@/modules/mcp/router/mcp.public.route';

const MaintenanceView = () => import('@/views/MaintenanceMode.vue');

const Forbidden = () => import('@/modules/forbidden/index.vue');
const NotFound = () => import('@/modules/notFound/index.vue');
const RemoteConfigTest = () => import('@/views/RemoteConfigTest.vue');

const publicRoutes: Array<RouteRecordRaw> = [
  ...authPublicRoutes,
  {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden,
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: MaintenanceView,
  },
  {
    path: '/remote-config-test',
    name: 'remote-config-test',
    component: RemoteConfigTest,
  },
  ...contactsPublicRoutes,
  ...legalRepConfirmationPublicRoutes,
  ...jumioRegularizationPublicRoutes,
  ...mcpPublicRoutes,
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
  },
];

publicRoutes.forEach((route) => {
  if (!route.meta) {
    route.meta = {};
  }
  route.meta['requiresAuth'] = false;
});

export default publicRoutes;
